// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SearchParametersContextProperties = {
  return_date?: string;
  days_to_departure?: number;
  departure_position_id: number;
  num_legs?: number;
  children: number;
  infants: number;
  youths?: number;
  is_discount_card_applied?: boolean;
  arrival_position_id: number;
  departure_date: string;
  adults: number;
  round_trip: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/search_parameters_context/jsonschema/2-0-0';
export const searchParametersContextName = 'search_parameters_context';
export class SearchParametersContext extends BaseTrackingContext<SearchParametersContextProperties> {
  constructor(properties: SearchParametersContextProperties) {
    super(searchParametersContextName, schema, properties);
  }
}
